<div class="wccard mb-2 d-flex justify-content-between px-3 py-2" style="color: #484b59;">

  <div class="d-flex">
    <span class="mr-3">
      <a data-testid="auto-app-campaign-header-a-1" class="text-webbtree-green" routerLinkActive="active" [routerLink]="listingPath"> <i class="fas fa-arrow-left"
          style="margin-top: 12px;
              "></i>
        Back
      </a>
    </span>
    <span>
      <div class="f-16 font-weight-600">{{campaignData?.campaignName}}</div>
      <div class="f-12">{{formatDate(campaignData?.created_on)}} | {{campaignData?.user?.firstname}} {{campaignData?.user?.lastname}}</div>
      <div class="f-12" style="color: #2e93a1;" *ngIf="queueSummary">{{queueSummary}}</div>
    </span>
  </div>

  <div class="d-flex align-items-center" style="gap: 12px;">
      <div class="d-flex align-items-center" *ngIf="canChangeCampaignStatus">
        <span class="mr-1">Status</span>
        <app-custom-dropdown
          [(ngModel)]="campaignStatus"
          (selectionChange)="changeStatus($event)">
          <app-dropdown-option [value]="1" label="Active"></app-dropdown-option>
          <app-dropdown-option [value]="2" label="Paused"></app-dropdown-option>
        </app-custom-dropdown>
        <!-- <select data-testid="auto-app-campaign-header-select-1" name="" class="email-dropdown" id="campaignStatus" [(ngModel)]="campaignStatus" (change)="changeStatus($event)" style=" outline: none; width: max-content; height: 35px;">
          <option value=1>Active</option>
          <option value=2>Paused</option>
          <option value=3>Draft</option>
        </select> -->
      </div>
      <!-- border-radius: 2px; border: solid 1px #d9d9d9; -->
      <span class="btn-trms-light" style=" cursor: pointer;"  (click)="navigateToStages()">
          Campaign steps
          <i class="fa-regular fa-arrow-up-right-from-square ml-1"></i>
      </span>
      <span class="mx-1 dropdown ats-dropBtn" *ngIf="canAddCandidates && (!showAddCandidatePage || (showAddCandidatePage && filters))">
        <button data-testid="auto-app-campaign-header-button-1" class="btn-trms-medium" type="button" id="userDropdownButton" appDropdownToggle aria-haspopup="true" aria-expanded="false"><i class="far fa-add mr-2"></i> New Candidate</button>
          <div class="dropdown-menu" aria-labelledby="userDropdownButton">
            <a data-testid="auto-app-campaign-header-a-2" class="dropdown-item" routerLink="/talent/talentpool">Talent Pool</a>
            <a data-testid="auto-app-campaign-header-a-3" class="dropdown-item" routerLink="/person/search">Search Listing</a>
            <a data-testid="auto-app-campaign-header-a-4" class="dropdown-item" routerLink="/talent/candidate-list">My Candidates</a>
          </div>
      </span>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
